import AddDeleteInstrumentForm from "./AddDeleteInstrumentForm";
import BulkAddDeleteInstrument from "./BulkAddDeleteInstrument";

const InsSettings = () => {
  return (
    <div className="p-3 flex flex-col justify-start items-start gap-3">
      <AddDeleteInstrumentForm />
      <BulkAddDeleteInstrument />
    </div>
  );
};

export default InsSettings;
